(function () {
    'use strict';

    angular
            .module('imnApp')
            .directive('loaderSection', loaderSection);

    function loaderSection() {

        var loaderTemplate = '' +
                '<div class="loader-container">' +
                '<div class="md-preloader">' +
                '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75">' +
                '<circle cx="37.5" cy="37.5" r="33.5" stroke-width="8"/>' +
                '</svg>' +
                '</div>' +
                '</div>';

        return {
            restrict: 'A',
            link: function (scope, element, attr) {
                scope.$watch(attr.loaderSection, function (value) {
                    if (value) {
                        var loader = angular.element(loaderTemplate);
                        loader.addClass(attr.loaderTheme || 'light')
                        element.append(loader);
                    } else {
                        element.find('.loader-container').remove();
                    }
                })
            }
        }
    }

})();